import { Injectable, TemplateRef, Type } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { BehaviorSubject } from 'rxjs';
export interface ModalConfig {
  nzTitle: string;
  nzContent: any;
  nzFooter?: TemplateRef<any> | null;
  nzOkText?: string;
  nzOkDanger?: boolean;
  nzCancelText?: string;
  nzOnOk?: () => any;
  nzOnCancel?: () => any;
  nzComponentParams?: any;
}

export interface CorpActionConfig {
  nzTitle: string;
  nzContent: any;
  nzFooter?: TemplateRef<any> | null;
  nzOkText?: string;
  nzOkDanger?: boolean;
  nzCancelText?: string;
  nzOnOk?: () => any;
  nzOnCancel?: () => any;
  nzComponentParams?: any;
}

@Injectable({ providedIn: 'root' })
export class ModalService {
  constructor(private modal: NzModalService) {}
  private sharedDataSource = new BehaviorSubject<any>('Default Message');
  currentData = this.sharedDataSource.asObservable();

  updateData(data: any) {
    this.sharedDataSource.next(data);
  }

  triggerModal(config: ModalConfig): NzModalRef {
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter ?? null,
      nzOkText: config.nzOkText ?? 'Yes',
      nzCancelText: config.nzCancelText ?? 'No',
      nzOkDanger: config.nzOkDanger ?? false,
      nzOnOk: config.nzOnOk ?? (() => console.log('OK')),
      nzOnCancel: config.nzOnCancel ?? (() => console.log('Cancel')),
    });
  }

  uploadDocumentsModal(config: ModalConfig): NzModalRef {
    this.updateData({
      isSingleFile: !!config.nzComponentParams?.isSingleFile,
      acceptedFormats:
        config.nzComponentParams?.acceptedFormats || '.docx,.xlsx,.pdf,.csv,.txt,.png',
      placeHolder: config.nzComponentParams?.acceptedFormats
        ? `You can upload individual ${config.nzComponentParams?.isSingleFile ? '' : 'multiple files'}in the following formats: ${config.nzComponentParams.acceptedFormats}`
        : 'You can upload individual or multiple files in the following formats: .docx, .xlsx, .pdf, .csv, .txt, .png',
    });
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
      nzData: {
        acceptedFormats:
          config.nzComponentParams?.acceptedFormats || '.docx,.xlsx,.pdf,.csv,.txt,.png',
      },
    });
  }

  aboutPopupModal(config: ModalConfig): NzModalRef {
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
    });
  }

  formModal(config: ModalConfig): NzModalRef {
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
    });
  }

  addnewfieldModal(config: ModalConfig): NzModalRef {
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
      nzData: { rowData: config.nzComponentParams.rowData || {} },
      nzWidth: '50%',
    });
  }

  updateChartConfigModal(config: ModalConfig): NzModalRef {
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
      nzData: { rowData: config.nzComponentParams.rowData || {} },
      nzWidth: '50%',
    });
  }

  corpActionsModal(config: CorpActionConfig): NzModalRef {
    const modalRef = this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
      nzData: { rowData: config.nzComponentParams?.rowData || {} },
      nzWidth: '50%',
      nzOnCancel: config.nzOnCancel ?? (() => modalRef.destroy()),
    });

    return modalRef;
  }

  saveViewModal(config: ModalConfig): NzModalRef {
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
      nzData: { data: config.nzComponentParams.rowData || {} },
      nzWidth: '50%',
    });
  }
  passwordResetModal(config: ModalConfig): NzModalRef {
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
      nzWidth: '35%',
    });
  }
  loadViewModal(config: ModalConfig): NzModalRef {
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
      nzWidth: '50%',
    });
  }
  addNewRolesPopupModal(config: ModalConfig): NzModalRef {
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
      nzData: { data: config?.nzComponentParams?.rowData || {} },
    });
  }

  assignRolesPopupModal(config: ModalConfig): NzModalRef {
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
      nzData: { data: config?.nzComponentParams?.rowData || {} },
    });
  }
   addNewPermissionPopupModal(config: ModalConfig): NzModalRef {
    return this.modal.create({
      nzCentered: true,
      nzTitle: config.nzTitle,
      nzContent: config.nzContent,
      nzFooter: config.nzFooter || null,
      nzData: { data: config?.nzComponentParams?.rowData || {} },
    });
  }
  
}
